<h1 matDialogTitle>
  {{ 'Attach' | translate }}
</h1>
<form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
  <ix-fieldset>
    <ix-select
      [formControlName]="dev.fcName"
      [label]="dev.label | translate"
      [tooltip]="dev.tooltip | translate"
      [options]="dev.options"
      [required]="true"
    ></ix-select>
    <ix-checkbox
      [formControlName]="expand.fcName"
      [label]="expand.label | translate"
      [tooltip]="expand.tooltip | translate"
    ></ix-checkbox>
  </ix-fieldset>

  <ix-form-actions>
    <button mat-button type="button" ixTest="cancel" [matDialogClose]="false">
      {{ 'Cancel' | translate }}
    </button>

    <button
      *ixRequiresRoles="[Role.FullAdmin]"
      mat-button
      type="submit"
      color="primary"
      ixTest="save"
      [disabled]="form.invalid || isFormLoading"
    >
      {{ 'Save' | translate }}
    </button>
  </ix-form-actions>
</form>
